import React from 'react';
import get_bundle from '../domain/get_bundle';
import Locale from '../domain/Locale';
import Product from '../domain/Product';
import Order from '../domain/Order';
import Registered from '../domain/Registered';
import Verified from '../domain/Verified';
import Email from '../domain/Email';
import Mobile from '../domain/Mobile';
import User from '../domain/User';
import countries from '../domain/countries';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  product: Product,
  user: User,
  order: t.maybe(Order)
})
export default class CouponContactForm extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {
      value: this.getInitialValue()
    };
  }

  getValue() {
    return  this.refs.CouponContactForm.getValue();
  }

  getCountriesOptions() {
    return countries.to_options(this.props.locale).map((country) => {
      return {
        value: country[0],
        text: countries.format_area(this.props.locale, country[0])
      };
    });
  }

  onChange = (value) => {
    if (value.go_invoice_form !== this.state.value.go_invoice_form) {
      $('#invoice_form').toggle();
    }

    this.setState({
      value
    });
  }

  getCountriesArray() {
    const countriesElements = [];
    for(const country in countries.data) {
      countriesElements.push(country);
    }
    return countriesElements;
  };

  getTypeForm() {
    const {user} = this.props;
    const countriesArray = this.getCountriesArray();
    const MobileCountry = t.enums.of(countriesArray);

    let CouponType = {
      coupon_name: t.Str,
      coupon_surname: t.Str,
      email: Email
    };

    if (Registered.is(user)) {
      CouponType.mobile_country = MobileCountry;
      CouponType.mobile = Mobile;
    } else if (Verified.is(user)) {
      CouponType.mobile = Mobile;
    }

    if (this.props.product.is_invoiced) {
      CouponType.go_invoice_form = t.Bool;
    }
    return t.struct(CouponType, 'CouponContact');
  }

  getOptionsForm() {
    const {user} = this.props;
    const bundle = get_bundle(this.props.locale).order;

    return {
      config: {horizontal: {
          md: [3, 9],
          sm: [6, 6]
        }
      },
      fields: {
        coupon_name: {
          label: bundle.coupon.name
        },
        coupon_surname: {
          label: bundle.coupon.surname,
          help: bundle.coupon.surname_hint
        },
        email: {
          label: bundle.coupon.email,
          type: 'static'
        },
        mobile_country: {
          label: bundle.coupon.mobile_country,
          options: this.getCountriesOptions()
        },
        mobile: {
          label: bundle.coupon.mobile,
          help: Registered.is(user) ? bundle.coupon.mobile_hint : '',
          type: Verified.is(user) ? 'static' : null
        },
        go_invoice_form: {
          label: bundle.is_invoiced
        }
      }
    };
  }

  getInitialValue() {
    const order = this.props.order;
    const doShowInvoice = !!order.invoice;
    return {
      coupon_name: order.coupon.name,
      coupon_surname: order.coupon.surname,
      email: order.coupon.email,
      mobile_country: order.coupon.mobile_country,
      mobile: order.coupon.mobile,
      go_invoice_form: doShowInvoice
    };
  }

  render() {
    return (
      <div className='form-horizontal'>
        <form>
          <t.form.Form
            ref="CouponContactForm"
            type={this.getTypeForm()}
            options={this.getOptionsForm()}
            value={this.state.value}
            onChange={this.onChange} />
        </form>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/CouponContactForm.js
 **/